import loader from '../../common/loader'; // import cookie from '../../common/cookie';
// import miloRequest from '../../common/network';

import platform from '../../common/platform';
import { loginCookie } from '../login/common'; // 道聚城多渠道接入 add by weiztang

var jsApi = 'https://ossweb-img.qq.com/images/js/milo_core/djcapptools.js'; // const qqAppid = '';
// const wxAppid = '';

var loginFuncsTips = 'please use LoginManager, not jsBridge';
var miloSelfConfig = {
  isMiloWayCookies: true,
  appName: 'djc'
}; // 加载jsBridge，活动开发可以自行指定版本号

var loadJsApi = function loadJsApi(jsApiCustom) {
  return new Promise(function (resolve) {
    var loadJsApiUrl = jsApiCustom || jsApi;

    if (window.DJCAppTools) {
      resolve(window.DJCAppTools);
      return;
    }

    loader.loadScript({
      url: loadJsApiUrl,
      charset: 'gbk'
    }).then(function (isLoad) {
      if (isLoad && window.DJCAppTools) {
        resolve(window.DJCAppTools);
      } else {
        reject();
      }
    })["catch"](function (e) {
      reject(e);
    }); // resolve();
  });
};

var loginByQQAndWX = function loginByQQAndWX() {
  // 这里执行道聚城自定义login逻辑 默认原有milo login.js逻辑不走
  loadJsApi().then(function (JsBridge) {
    JsBridge.login('all');
  })["catch"](function (e) {
    console.log('[Milo Core]loginByQQAndWX Load DJC Bridge Error:', e);
  });
};

var loginByWX = function loginByWX() {
  // 这里执行道聚城自定义login逻辑 默认原有milo login.js逻辑不走
  loadJsApi().then(function (JsBridge) {
    JsBridge.login('wx');
  })["catch"](function (e) {
    console.log('[Milo Core]loginByWX Load DJC Bridge Error:', e);
  });
};

var loginByQQ = function loginByQQ() {
  // 这里执行道聚城自定义login逻辑 默认原有milo login.js逻辑不走
  loadJsApi().then(function (JsBridge) {
    JsBridge.login('qq');
  })["catch"](function (e) {
    console.log('[Milo Core]loginByQQ Load DJC Bridge Error:', e);
  });
};

var setAppCookie = function setAppCookie() {
  return new Promise(function (resolve) {
    console.log(loginFuncsTips);
    resolve();
  });
};

var getLoginType = function getLoginType() {
  return new Promise(function (resolve) {
    // 这里执行道聚城自定义checklogin逻辑 通过await来拦截展示道聚城的UI
    loadJsApi().then(function (JsBridge) {
      JsBridge.checkLogin(resolve);
    })["catch"](function (e) {
      console.log('[Milo Core]getLoginType Load DJC Bridge Error:', e);
      resolve(null);
    });
  });
};

var logout = function logout() {
  loginCookie.clearLocal();
  loginCookie.clearQQ();
};

var djc = {
  loginByWX: loginByWX,
  loginByQQ: loginByQQ,
  loginByQQAndWX: loginByQQAndWX,
  setAppCookie: setAppCookie,
  getLoginType: getLoginType,
  logout: logout,
  loadJsApi: loadJsApi,
  miloSelfConfig: miloSelfConfig
};
export default djc;